import { UserCondensedListQueryDocument as __graphqlDocument0 } from 'store/client/documents/UserCondensedListQueryDocument'; 

export const userCondensedListQuery = __graphqlDocument0
























































;
